import { PropsWithChildren, useLayoutEffect, useState } from 'react';

import { To } from 'react-router';

import { PageLoader } from 'src/components/PageLoader';
import { APP_ROUTES } from 'src/constants/routes';
import { detectEnvironmentPlatform } from 'src/features/config/AppEnvironmentDetector/utils';
import { useNavigateWithQuery } from 'src/hooks/useNavigateWithQuery';

const REDIRECT_IGNORE_ROUTES = [
  APP_ROUTES.TEAMS_AUTH,
  APP_ROUTES.WEBEX,
  APP_ROUTES.TERMS,
  APP_ROUTES.EXTERNAL_AUTH,
  APP_ROUTES.SUPPORT_TERMS,
  APP_ROUTES.CA_TERMS,
  APP_ROUTES.CONSENT,
  APP_ROUTES.SERVICE_UNAVAILABLE,
  APP_ROUTES.SERVER_ERROR,
] as const;

export const AppEnvironmentDetector = ({ children }: PropsWithChildren) => {
  const [loading, setLoading] = useState<boolean>(true);

  const navigate = useNavigateWithQuery();

  useLayoutEffect(() => {
    const detectEnvironment = async (): Promise<string> => {
      if (window.location.pathname.includes(APP_ROUTES.TERMS)) {
        return 'web';
      }

      return detectEnvironmentPlatform();
    };

    const environment = detectEnvironment();

    environment.then(async (env) => {
      setLoading(false);

      await new Promise((resolve) => {
        setTimeout(() => resolve(true), 300);
      });

      // Ignore platform redirect if we are in MS teams auth flow or inside WEBEX platform
      if (
        window.location.pathname.startsWith(`/${env}`) ||
        REDIRECT_IGNORE_ROUTES.some((route) =>
          window.location.pathname.includes(route),
        )
      ) {
        return;
      }

      const envsRoutesMap: Record<string, string> = {
        zoom: APP_ROUTES.ZOOM,
        teams: APP_ROUTES.TEAMS,
        webex: APP_ROUTES.WEBEX,
        'google-meet': APP_ROUTES.MEET,
      };

      navigate(`${(envsRoutesMap[env] ?? APP_ROUTES.WEB) as To}`, {
        replace: true,
      });
    });
    // eslint-disable-next-line
  }, []);

  if (loading) {
    return <PageLoader />;
  }

  return <>{children}</>;
};
